import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useState } from 'react';
import clsx from 'clsx';
import { CheckboxPrimitive } from '../checkbox-primitive/checkbox-primitive.js';
import { checkbox, muted, visuals, root, changed, iconMixed, iconMixedShadow, iconCheck, iconCheckShadow } from './manually-labeled-checkbox.css.js';

function CheckIconShadow() {
    return (jsx("svg", { className: clsx(iconCheck, iconCheckShadow), width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", children: jsx("path", { d: "M5.00012 8.5L7.5 11L11.5 5", stroke: "var(--fpl-icon-color, var(--color-icon))", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", shapeRendering: "geometricPrecision" }) }));
}
CheckIconShadow.displayName = 'CheckIconShadow';
function CheckIcon() {
    return (jsx("svg", { className: iconCheck, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", children: jsx("path", { d: "M5.00012 8.5L7.5 11L11.5 5", stroke: "var(--fpl-icon-color, var(--color-icon))", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", shapeRendering: "geometricPrecision" }) }));
}
CheckIcon.displayName = 'CheckIcon';
function MixedIconShadow() {
    return (jsx("svg", { className: clsx(iconMixed, iconMixedShadow), width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", children: jsx("path", { d: "M5 8H11", stroke: "var(--fpl-icon-color, var(--color-icon))", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", shapeRendering: "crispEdges" }) }));
}
MixedIconShadow.displayName = 'MixedIconShadow';
function MixedIcon() {
    return (jsx("svg", { className: iconMixed, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", children: jsx("path", { d: "M5 8H11", stroke: "var(--fpl-icon-color, var(--color-icon))", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", shapeRendering: "crispEdges" }) }));
}
MixedIcon.displayName = 'MixedIcon';
/**
 * Used for binary choices where you need complete control over the placement of the label.
 * @see https://fpl.figma.design/components/inputs/checkbox/#manuallylabeledcheckbox
 */
const ManuallyLabeledCheckbox = forwardRef(({ muted: muted$1, variant, ...props }, ref) => {
    const isMuted = muted$1 || variant === 'muted';
    const [isDirty, setIsDirty] = useState(false);
    const handleChange = (value, other) => {
        setIsDirty(true);
        props.onChange?.(value, other);
    };
    return (jsxs("span", { "data-fpl-component": "", className: clsx(root, { [changed]: isDirty }), "data-disabled": props.disabled ? true : undefined, children: [jsx(CheckboxPrimitive, { ref: ref, ...props, onChange: handleChange, className: clsx(checkbox, { [muted]: isMuted }) }), jsxs("span", { className: visuals, children: [jsx(MixedIconShadow, {}), jsx(MixedIcon, {}), jsx(CheckIconShadow, {}), jsx(CheckIcon, {})] })] }));
});
ManuallyLabeledCheckbox.displayName = 'ManuallyLabeledCheckbox';

export { ManuallyLabeledCheckbox };
//# sourceMappingURL=manually-labeled-checkbox.js.map
